// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_M6U","cls2":"ReferenceReportPage-cls2_CxK ReferenceReportPage-cls1_M6U"};